import DieMiniature from './DieMiniature';

// The same story beats remain visible without a GPU, including context loss.
const LastSignalFallback = ({ variant, dieId, faceValues }) => (
  <div className="lastSignalFallback" aria-hidden="true">
    <svg viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">
      <defs>
        <radialGradient id="lastSignalGalaxyGlow">
          <stop stopColor="#fff3cf" />
          <stop offset=".12" stopColor="#b5dfff" />
          <stop offset=".45" stopColor="#826bdc" stopOpacity=".55" />
          <stop offset="1" stopColor="#503075" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="lastSignalCoreGlow">
          <stop stopColor="#f2c2ff" />
          <stop offset=".2" stopColor="#9745c9" />
          <stop offset="1" stopColor="#130c29" />
        </radialGradient>
        <pattern
          id="lastSignalLoomGrid"
          width="40"
          height="40"
          patternUnits="userSpaceOnUse"
        >
          <rect
            x="3"
            y="3"
            width="33"
            height="33"
            rx="2"
            fill="#143645"
            stroke="#84f5eb"
          />
        </pattern>
      </defs>
      <g className="lastSignalFallbackStars" fill="#b8d9fa">
        {Array.from({ length: 160 }, (_, index) => (
          <circle
            key={index}
            cx={(index * 137 + 19) % 1200}
            cy={(index * 83 + 47) % 800}
            r={index % 7 ? 0.8 : 1.6}
          />
        ))}
      </g>
      <g className="lastSignalFallbackGalaxies">
        {[
          [430, 245, 1, -18],
          [970, 130, 0.45, 25],
          [150, 420, 0.4, 12],
        ].map(([x, y, scale, tilt], index) => (
          <g
            key={index}
            transform={`translate(${x} ${y}) rotate(${tilt}) scale(${scale})`}
          >
            <ellipse rx="290" ry="130" fill="url(#lastSignalGalaxyGlow)" />
            <g fill="none" stroke="#bdb6ff" strokeWidth="1" opacity=".7">
              <path d="M0 0C-110-95-270-45-225 20S-45 90 12 0 250-65 245 0" />
              <path d="M0 0C80 95 250 60 230-5S30-85-10 0-260 70-240-5" />
              <ellipse rx="190" ry="60" strokeDasharray="1 5" />
              <ellipse rx="250" ry="92" strokeDasharray="1 9" />
            </g>
          </g>
        ))}
      </g>
      <g className="lastSignalFallbackFracture" stroke="#e687ff" fill="none">
        <path
          d="M0 180 150 220 235 195 350 244 480 215 570 260 710 220 830 280 960 240 1200 290"
          strokeWidth="3"
        />
        <path
          d="M0 190 150 230 235 205 350 254 480 225 570 270 710 230 830 290 960 250 1200 300"
          opacity=".35"
          strokeWidth="9"
        />
      </g>
      <g
        className="lastSignalFallbackCore"
        transform={
          variant === 'arrival'
            ? 'translate(600 270)'
            : 'translate(950 210) scale(.4)'
        }
      >
        <g className="lastSignalFallbackRings" fill="none" strokeWidth="1.5">
          <ellipse rx="205" ry="70" transform="rotate(-32)" stroke="#bb8eff" />
          <ellipse rx="225" ry="90" transform="rotate(35)" stroke="#ff8cd9" />
          <ellipse rx="190" ry="145" transform="rotate(70)" stroke="#79eaff" />
        </g>
        <g className="lastSignalFallbackShell">
          <path
            d="M0-85 72-45 80 35 0 88-74 40-76-40Z"
            fill="url(#lastSignalCoreGlow)"
            stroke="#d4a3ff"
            strokeWidth="2"
          />
          <path
            d="M0-85 6-5 72-45 M6-5 80 35 M6-5 0 88 M6-5-74 40 M6-5-76-40"
            fill="none"
            stroke="#cf9af8"
          />
        </g>
      </g>
      <g className="lastSignalFallbackLoom" transform="translate(590 425)">
        <g transform="matrix(1 .25 -.85 .48 -12 -40)">
          <rect
            x="-110"
            y="-100"
            width="220"
            height="220"
            fill="#041421"
            stroke="#8ffff1"
          />
          <rect
            x="-100"
            y="-90"
            width="200"
            height="200"
            fill="url(#lastSignalLoomGrid)"
          />
        </g>
        <path
          d="M-340-80Q-100-180 0-5"
          fill="none"
          stroke="#a6fff1"
          strokeWidth="1.5"
          className="lastSignalFallbackThread"
        />
        <circle cx="-340" cy="-80" r="5" fill="#c7fff0" />
      </g>
    </svg>
    <div className="lastSignalFallbackDie">
      <DieMiniature dieId={dieId} faceValues={faceValues} />
    </div>
  </div>
);

export default LastSignalFallback;
